import moment from 'moment';
import { moneyFormatFromCents } from 'utilities/moneyFormat';

const squash = (text) => (text || '').toLowerCase().replace(/[^a-z0-9]/g, '');

/**
 * What the bank calls the transaction, when that is not just what it is called here: "PAYPAL *INST
 * XFER" beside a "PayPal" is worth showing, a difference only in case or spacing is not.
 */
export function bankName(transaction) {
	const bankTransaction = transaction.getPlaidTransaction ? transaction.getPlaidTransaction() : null;
	const name = bankTransaction ? bankTransaction.name : null;
	if(!name || squash(name) === squash(transaction.where)) {
		return null;
	}
	return name;
}

/** "Today", "Yesterday", "Thursday, 3 days ago", or the weekday and how long ago for anything further off. */
export function dateHint(date, today = moment()) {
	if(!date || !date.isValid()) {
		return null;
	}
	const days = today.clone().startOf('day').diff(date.clone().startOf('day'), 'days');
	if(days === 0) {
		return 'Today';
	}
	if(days === 1) {
		return 'Yesterday';
	}
	if(days === -1) {
		return 'Tomorrow';
	}
	if(days > 1 && days < 7) {
		return `${date.format('dddd')}, ${days} days ago`;
	}
	return `${date.format('dddd')}, ${date.clone().startOf('day').from(today.clone().startOf('day'))}`;
}

/**
 * How the splits stand against the total: all of it assigned, some still to assign, or more assigned
 * than there is. Null for a transaction that is not split.
 */
export function splitStatus(transaction) {
	if(!transaction.isSplit()) {
		return null;
	}
	const remaining = transaction.getUnsplitAmount();
	if(remaining === 0) {
		return { ok: true, text: 'Every cent is assigned.' };
	}
	const over = transaction.amount === 0 ? true : Math.sign(remaining) !== Math.sign(transaction.amount);
	return over ?
		{ ok: false, text: `The splits add up to ${moneyFormatFromCents(Math.abs(remaining))} more than the total.` } :
		{ ok: false, text: `${moneyFormatFromCents(Math.abs(remaining))} left to assign.` };
}
